export const fixeButton = () => {

  let button = document.getElementById("btn-link-mevo");

  window.addEventListener('scroll', () => {

    let currentScroll = window.scrollY;
    let height = window.innerHeight;

    if (currentScroll >= height) {

      button.style.top = "initial";
      button.style.right = "30px";
      button.style.bottom = "30px";
      button.style.position = "fixed";

    } else {

      button.style.top = "80px";
      button.style.right = "-90px";
      button.style.bottom = "initial";
      button.style.position = "absolute";

    }

  });

};